module.exports = __webpack_public_path__ + "static/media/coupa_logo2013_RGB_rev_LowRes.f84dcb06.png";